import { useState, useCallback } from "react";
/**
 * This hook can be used to control the state of a radio group or a select
 * element.
 *
 * @param defaultValue The default value. If you want the user to specifically
 * choose a value, set this to the empty string.
 * @param onChange An optional change event handler to also call when the change
 * event is triggered.
 * @return a list containing the current value, a change event handler, and then
 * a manual value setter.
 */
export default function useChoice(defaultValue, onChange) {
    var _a = useState(defaultValue), value = _a[0], setValue = _a[1];
    var handleChange = useCallback(function (event) {
        if (onChange) {
            onChange(event);
        }
        setValue(event.currentTarget.value);
    }, [onChange]);
    return [value, handleChange, setValue];
}
//# sourceMappingURL=useChoice.js.map